import { render, staticRenderFns } from "./DialogHistoryUser.vue?vue&type=template&id=6a1aba1e"
import script from "./DialogHistoryUser.vue?vue&type=script&lang=js"
export * from "./DialogHistoryUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports